export { default } from './FortuneCallout';
export type { Props as FortuneCalloutProps, ColorProp } from './FortuneCallout';
